module.exports = __webpack_public_path__ + "img/68b8369b7c9e48148befc1d702d3390a.31f41fbc.jpg";